// JsFromRoutes CacheKey feecd391284222a444a687bf1a528355
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/booking_available_dates'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/booking_available_dates'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/workspace/:venue_slug/booking_available_dates/:id'),
}
